function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { CvsdkError, ErrorSeverity } from '../../../error';
import { sdkLogger } from '../../../logger';
import { AdPolicyManagerContentTimeAdapter } from '../../../propositions/ad-policy/ad-policy-manager-content-time-adapter';
import { Observable } from '../../../utils/observables/observable';
import { checkIsManifestLinearType } from '../../../utils/playback-type';
import { PlayerState } from '../../player/player-state';
import { StreamQuality } from '../../player/playout-data';
import { BufferingLimit } from './buffering-limit';
import { CdnSelector } from './cdn-selector';
import { Timeline, TimelineItemType } from './timeline';
import { TimelineError } from './timeline-error';
import { TimelinePlayerCreationHelper } from './timeline-player-creation-helper';
import { VideoFormat } from '../../player/video-format';
import { PerfKey, PerfTag, perfLogger } from '../../../utils/perf';
import { TimelineState } from './timeline.enums';
export { TimelineState } from './timeline.enums';
import { areAdBreaksSame, cloneAdBreak, cloneAdBreakArray } from '../../../utils/ad-break-utils';
import { JsonUtils } from '../../../utils/json-utils';
var PRELOAD_BUFFERING_SECS = 10;
var LINEAR_BREAK_OFFSET_SECS = 0.5;
var MAX_SEEKING_WAIT_MS = 300;
function isNumber(v) {
    return typeof v === 'number';
}
export var TimelineManager = /*#__PURE__*/ function() {
    "use strict";
    function TimelineManager(playerEngine, config, options, sessionPrecursor, session) {
        var _this = this;
        _class_call_check(this, TimelineManager);
        var _this1 = this;
        _define_property(this, "playerEngine", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "options", void 0);
        _define_property(this, "sessionPrecursor", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "timeline", void 0);
        _define_property(this, "playerEngineItems", void 0);
        _define_property(this, "currentTimelineItem", void 0);
        _define_property(this, "endingPlayerEngineItemPromise", void 0);
        _define_property(this, "timelineState", void 0);
        _define_property(this, "timelineItemStartedObservable", void 0);
        _define_property(this, "timelineItemPlayoutObservable", void 0);
        _define_property(this, "timelineItemPlayoutRulesObservable", void 0);
        _define_property(this, "timelineItemEndedObservable", void 0);
        _define_property(this, "timelineFinishedObservable", void 0);
        _define_property(this, "timelineItemPreloadingObservable", void 0);
        _define_property(this, "timelineEndedObservable", void 0);
        _define_property(this, "timelineErrorObservable", void 0);
        _define_property(this, "qualityFailoverObservable", void 0);
        _define_property(this, "cdnSwitchedObservable", void 0);
        _define_property(this, "adBreakFinishedObservable", void 0);
        _define_property(this, "cdnSelector", void 0);
        _define_property(this, "bufferingLimit", void 0);
        _define_property(this, "mainAsset", void 0);
        _define_property(this, "adTimelineItemToAd", void 0);
        _define_property(this, "exactEndOfTimelineItemTimeout", void 0);
        _define_property(this, "previousBreakStartClock", void 0);
        _define_property(this, "previousBreakExpectedDuration", void 0);
        _define_property(this, "interItemAdPolicyManager", void 0);
        _define_property(this, "mainContentIsLinear", void 0);
        _define_property(this, "timelinePlayerCreationHelper", void 0);
        _define_property(this, "timelinePreconstructPreloadPromises", void 0);
        _define_property(this, "handlePlayerPositionUpdate", void 0);
        _define_property(this, "qualityFailoverIntercept", void 0);
        this.playerEngine = playerEngine;
        this.config = config;
        this.options = options;
        this.sessionPrecursor = sessionPrecursor;
        this.session = session;
        this.logger = null;
        this.playerEngineItems = new Map();
        this.currentTimelineItem = null;
        this.endingPlayerEngineItemPromise = {};
        this.timelineState = TimelineState.WaitingToStart;
        this.timelineItemStartedObservable = new Observable();
        this.timelineItemPlayoutObservable = new Observable();
        this.timelineItemPlayoutRulesObservable = new Observable();
        this.timelineItemEndedObservable = new Observable();
        this.timelineFinishedObservable = new Observable();
        this.timelineItemPreloadingObservable = new Observable();
        this.timelineEndedObservable = new Observable();
        this.timelineErrorObservable = new Observable();
        this.qualityFailoverObservable = new Observable();
        this.cdnSwitchedObservable = new Observable();
        this.adBreakFinishedObservable = new Observable();
        this.adTimelineItemToAd = new Map();
        this.timelinePreconstructPreloadPromises = new Map();
        this.handlePlayerPositionUpdate = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(playerEngineItem, position) {
                var _this_currentTimelineItem, _this_currentTimelineItem1, _this_logger, _this_currentTimelineItem2, _this_currentTimelineItem3, _this_currentTimelineItem4, _this_timeline, _this_currentTimelineItem5, logPrefix, itemEndTime, timeUntilItemEnd, _CoreVideoInternal_playerCapabilities_preloadBufferTimeSecs, isNearItemEnd, nextTimelineItem;
                return _ts_generator(this, function(_state) {
                    logPrefix = _this1.getLogPrefix(playerEngineItem);
                    (_this_currentTimelineItem = _this1.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.asset.notifyPositionChanged(position);
                    (_this_logger = _this1.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.verbose("".concat(logPrefix, " at position ").concat(position.toFixed(2), ". Ending at ").concat((_this_currentTimelineItem1 = _this1.currentTimelineItem) === null || _this_currentTimelineItem1 === void 0 ? void 0 : _this_currentTimelineItem1.endTime, "."));
                    if (((_this_currentTimelineItem2 = _this1.currentTimelineItem) === null || _this_currentTimelineItem2 === void 0 ? void 0 : _this_currentTimelineItem2.type) === TimelineItemType.Advert) {
                        _this1.updateAdPosition(_this1.currentTimelineItem, position);
                    }
                    itemEndTime = isNumber((_this_currentTimelineItem3 = _this1.currentTimelineItem) === null || _this_currentTimelineItem3 === void 0 ? void 0 : _this_currentTimelineItem3.endTime) ? (_this_currentTimelineItem4 = _this1.currentTimelineItem) === null || _this_currentTimelineItem4 === void 0 ? void 0 : _this_currentTimelineItem4.endTime : playerEngineItem.duration;
                    if (!itemEndTime) {
                        return [
                            2
                        ];
                    }
                    timeUntilItemEnd = itemEndTime - position;
                    isNearItemEnd = timeUntilItemEnd < ((_CoreVideoInternal_playerCapabilities_preloadBufferTimeSecs = CoreVideoInternal.playerCapabilities.preloadBufferTimeSecs) !== null && _CoreVideoInternal_playerCapabilities_preloadBufferTimeSecs !== void 0 ? _CoreVideoInternal_playerCapabilities_preloadBufferTimeSecs : PRELOAD_BUFFERING_SECS);
                    if (!isNearItemEnd) {
                        return [
                            2
                        ];
                    }
                    nextTimelineItem = (_this_timeline = _this1.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getNextTimelineItem(_this1.currentTimelineItem);
                    if (nextTimelineItem) {
                        _this1.handlePreconstructAndPreload(nextTimelineItem);
                    }
                    if (((_this_currentTimelineItem5 = _this1.currentTimelineItem) === null || _this_currentTimelineItem5 === void 0 ? void 0 : _this_currentTimelineItem5.endTime) !== 'end') {
                        self.clearTimeout(_this1.exactEndOfTimelineItemTimeout);
                        _this1.exactEndOfTimelineItemTimeout = _this1.scheduleTransitionToNextItem(_this1.currentTimelineItem, position, itemEndTime, logPrefix);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(playerEngineItem, position) {
                return _ref.apply(this, arguments);
            };
        }();
        this.qualityFailoverIntercept = function() {
            var _this_logger;
            _this.qualityFailoverObservable.notifyObservers(VideoFormat.HD);
            var message = 'UHD quality failover to HD - preventing CDN switch';
            (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.warn(message);
            _this.handleTimelineError(new TimelineError({
                message: message,
                code: 'SDK.QUALITY.FAILOVER',
                cause: 'UHD asset unable to be played, quality switch over to HD'
            }, _this.currentTimelineItem.type), false);
            return;
        };
        this.cdnSelector = new CdnSelector();
        this.mainContentIsLinear = checkIsManifestLinearType(options.playbackType);
        this.bufferingLimit = new BufferingLimit(this.config.bufferingLimit, session, CoreVideoInternal.bandwidthEstimator);
        this.bufferingLimit.onBufferingLimitReached(function(e) {
            _this.handleTimelineError(new TimelineError({
                message: e.message,
                code: "SDK.".concat(e.code),
                parameters: e.stats
            }, _this.currentTimelineItem.type), e.shouldFailSilently);
        }, this);
        this.onTimelineItemStarted(function(timelineEventData) {
            return _this.bufferingLimit.playerEngineItemChanged(timelineEventData);
        }, this);
    }
    _create_class(TimelineManager, [
        {
            key: "initializeTimeline",
            value: function initializeTimeline(mainAsset, advertBoltOns, drmBoltOns, adInsertionConfig) {
                var _this = this;
                var modifiedAdvertBoltOns = advertBoltOns;
                if (adInsertionConfig === null || adInsertionConfig === void 0 ? void 0 : adInsertionConfig.isTimelineAdManagementRequired) {
                    this.interItemAdPolicyManager = new AdPolicyManagerContentTimeAdapter(advertBoltOns.policyManager, this.options.playbackType);
                    modifiedAdvertBoltOns = _object_spread_props(_object_spread({}, advertBoltOns), {
                        policyManager: undefined
                    });
                    this.interItemAdPolicyManager.onShouldSeek(function(position) {
                        return _this.performSeek(position, true);
                    });
                }
                this.mainAsset = mainAsset;
                this.timeline = new Timeline(mainAsset, this.options);
                this.logger = sdkLogger.withContext(this.timeline.id);
                this.timelinePlayerCreationHelper = new TimelinePlayerCreationHelper(this.playerEngine, this.sessionPrecursor, modifiedAdvertBoltOns, drmBoltOns);
            }
        },
        {
            key: "startTimeline",
            value: function startTimeline() {
                var startPosition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var _this = this;
                return _async_to_generator(function() {
                    var _this_timeline, _this_logger, _this_timeline1, managedStartPosition, adTimelineItemToPlay, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, timelineItem, adBreak, _this_interItemAdPolicyManager, timelineItem1;
                    return _ts_generator(this, function(_state) {
                        if (_this.timelineState !== TimelineState.WaitingToStart) return [
                            2
                        ];
                        _this.timelineState = TimelineState.Started;
                        (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("Timeline starting:\n".concat((_this_timeline = _this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.toString()));
                        managedStartPosition = _this.interItemAdPolicyManager ? _this.interItemAdPolicyManager.manageStartPosition(startPosition) : startPosition;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (_this.interItemAdPolicyManager) try {
                            for(_iterator = _this.adTimelineItemToAd[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = _sliced_to_array(_step.value, 2), timelineItem = _step_value[0], adBreak = _step_value[1].adBreak;
                                ;
                                if ((Number(adBreak.position) || 0) <= managedStartPosition && ((_this_interItemAdPolicyManager = _this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager === void 0 ? void 0 : _this_interItemAdPolicyManager.shouldPlayAdBreak(adBreak, managedStartPosition, managedStartPosition > 0))) {
                                    adTimelineItemToPlay = timelineItem;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (adTimelineItemToPlay) return [
                            2,
                            _this.playTimelineItem(adTimelineItemToPlay, true)
                        ];
                        timelineItem1 = (_this_timeline1 = _this.timeline) === null || _this_timeline1 === void 0 ? void 0 : _this_timeline1.getMainContentItemForPosition(managedStartPosition);
                        return [
                            2,
                            _this.playTimelineItem(timelineItem1, true, managedStartPosition)
                        ];
                    });
                })();
            }
        },
        {
            key: "endTimeline",
            value: function endTimeline() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_logger, _this_timeline, nextItem, endPromises;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.timelineState === TimelineState.Ended) {
                                    return [
                                        2
                                    ];
                                }
                                _this.timelineState = TimelineState.Ended;
                                if (!_this.currentTimelineItem) return [
                                    3,
                                    2
                                ];
                                nextItem = (_this_timeline = _this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getNextTimelineItem(_this.currentTimelineItem);
                                endPromises = [
                                    _this.endTimelineItem(_this.currentTimelineItem)
                                ];
                                if (nextItem) {
                                    endPromises.push(_this.endTimelineItem(nextItem));
                                }
                                return [
                                    4,
                                    Promise.all(endPromises)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _this.currentTimelineItem = null;
                                _this.timelineEndedObservable.notifyObservers();
                                _this.destroy();
                                (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("Timeline ended.");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifySessionOfClonedAdBreakData",
            value: function notifySessionOfClonedAdBreakData(adBreaks) {
                var clonedAdBreaks = cloneAdBreakArray(adBreaks);
                this.session.notifyAdBreakDataReceived(clonedAdBreaks);
            }
        },
        {
            key: "insertAdverts",
            value: function insertAdverts(adAssetGroup) {
                var _this = this;
                var _this_interItemAdPolicyManager, _this_interItemAdPolicyManager1;
                var assets = adAssetGroup.assets, position = adAssetGroup.position, adBreak = adAssetGroup.adBreak;
                var addedItems;
                var isPreroll = position === 0 || position === 'start';
                if (this.mainContentIsLinear && !isPreroll) {
                    var _this_timeline;
                    if (!isNumber(position)) {
                        var _this_logger;
                        (_this_logger = this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.warn('Received an unexpected live break position: ', position);
                        return;
                    }
                    addedItems = (_this_timeline = this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.insertAdverts(assets, position - LINEAR_BREAK_OFFSET_SECS, adBreak.expectedDuration + LINEAR_BREAK_OFFSET_SECS);
                } else {
                    var _this_timeline1;
                    addedItems = (_this_timeline1 = this.timeline) === null || _this_timeline1 === void 0 ? void 0 : _this_timeline1.insertAdverts(assets, position, adBreak.expectedDuration);
                }
                addedItems === null || addedItems === void 0 ? void 0 : addedItems.forEach(function(item, i) {
                    // note the assumption here that the array of ads
                    // corresponds exactly to the array of assets
                    // and that the array of assets corresponds exactly
                    // to the array of timeline items.
                    var matchingAd = adBreak.ads[i];
                    _this.adTimelineItemToAd.set(item, {
                        ad: matchingAd,
                        adBreak: adBreak
                    });
                });
                var _this_interItemAdPolicyManager_getAdBreaks;
                var adBreaksData = _to_consumable_array((_this_interItemAdPolicyManager_getAdBreaks = (_this_interItemAdPolicyManager = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager === void 0 ? void 0 : _this_interItemAdPolicyManager.getAdBreaks()) !== null && _this_interItemAdPolicyManager_getAdBreaks !== void 0 ? _this_interItemAdPolicyManager_getAdBreaks : []).concat([
                    adBreak
                ]);
                (_this_interItemAdPolicyManager1 = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager1 === void 0 ? void 0 : _this_interItemAdPolicyManager1.setAdBreaksData(adBreaksData);
                this.notifySessionOfClonedAdBreakData(adBreaksData);
            }
        },
        {
            key: "removeAdverts",
            value: function removeAdverts(adAssetGroup) {
                var _this = this;
                var _this_timeline, _this_interItemAdPolicyManager, _this_interItemAdPolicyManager1;
                var assets = adAssetGroup.assets, adBreak = adAssetGroup.adBreak;
                var removedItems = (_this_timeline = this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.removeAdverts(assets);
                var existingAdBreaks = (_this_interItemAdPolicyManager = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager === void 0 ? void 0 : _this_interItemAdPolicyManager.getAdBreaks();
                removedItems === null || removedItems === void 0 ? void 0 : removedItems.forEach(function(item) {
                    return _this.adTimelineItemToAd.delete(item);
                });
                var adBreaksData = existingAdBreaks.filter(function(x) {
                    return !areAdBreaksSame(x, adBreak);
                });
                (_this_interItemAdPolicyManager1 = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager1 === void 0 ? void 0 : _this_interItemAdPolicyManager1.setAdBreaksData(adBreaksData);
                this.notifySessionOfClonedAdBreakData(adBreaksData);
            }
        },
        {
            key: "seek",
            value: function seek(targetContentPosition) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_currentTimelineItem, _this_currentTimelineItem1, _this_getCurrentPlayerEngineItem, // don't allow seeking while an ad timeline item is playing or in the process of suspending
                    _this_logger, currentContentPosition, targetPosition;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (((_this_currentTimelineItem = _this.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.type) === TimelineItemType.Advert || ((_this_currentTimelineItem1 = _this.currentTimelineItem) === null || _this_currentTimelineItem1 === void 0 ? void 0 : _this_currentTimelineItem1.isSuspending)) {
                                    ;
                                    (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.warn('Seeking cannot be performed as either an advert is playing or timeline item is suspending');
                                    return [
                                        2
                                    ];
                                }
                                self.clearTimeout(_this.exactEndOfTimelineItemTimeout);
                                currentContentPosition = _this.currentTimelineItem && ((_this_getCurrentPlayerEngineItem = _this.getCurrentPlayerEngineItem()) === null || _this_getCurrentPlayerEngineItem === void 0 ? void 0 : _this_getCurrentPlayerEngineItem.getCurrentPosition()) || 0;
                                targetPosition = _this.interItemAdPolicyManager ? _this.interItemAdPolicyManager.manageSeek(currentContentPosition, targetContentPosition) : targetContentPosition;
                                return [
                                    4,
                                    _this.performSeek(targetPosition)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "seeked",
            value: function seeked() {
                var _this_interItemAdPolicyManager;
                (_this_interItemAdPolicyManager = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager === void 0 ? void 0 : _this_interItemAdPolicyManager.seekEnded();
            }
        },
        {
            key: "onTimelineItemStarted",
            value: function onTimelineItemStarted(callback, owner) {
                this.timelineItemStartedObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onTimelineItemPlayoutReceived",
            value: function onTimelineItemPlayoutReceived(callback, owner) {
                this.timelineItemPlayoutObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onTimelineItemPlayoutRulesReceived",
            value: function onTimelineItemPlayoutRulesReceived(callback, owner) {
                this.timelineItemPlayoutRulesObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onTimelineItemEnded",
            value: function onTimelineItemEnded(callback, owner) {
                this.timelineItemEndedObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onTimelineItemPreloading",
            value: function onTimelineItemPreloading(callback, owner) {
                this.timelineItemPreloadingObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onTimelineEnded",
            value: function onTimelineEnded(callback, owner) {
                this.timelineEndedObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onTimelineFinished",
            value: function onTimelineFinished(callback, owner) {
                this.timelineFinishedObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "onError",
            value: function onError(callback, callbackOwner) {
                this.timelineErrorObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onQualityFailover",
            value: function onQualityFailover(callback, callbackOwner) {
                this.qualityFailoverObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onCdnSwitch",
            value: function onCdnSwitch(callback, callbackOwner) {
                this.cdnSwitchedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdBreakFinished",
            value: function onAdBreakFinished(callback) {
                this.adBreakFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(owner) {
                this.timelineItemStartedObservable.unregisterObservers(owner);
                this.timelineItemEndedObservable.unregisterObservers(owner);
                this.timelineEndedObservable.unregisterObservers(owner);
                this.timelineErrorObservable.unregisterObservers(owner);
                this.qualityFailoverObservable.unregisterObservers(owner);
                this.cdnSwitchedObservable.unregisterObservers(owner);
                this.timelineItemPlayoutObservable.unregisterObservers(owner);
                this.timelineItemPlayoutRulesObservable.unregisterObservers(owner);
                this.timelineItemPreloadingObservable.unregisterObservers(owner);
                this.timelineFinishedObservable.unregisterObservers(owner);
                this.adBreakFinishedObservable.unregisterObservers(owner);
            }
        },
        {
            key: "performSeek",
            value: function performSeek(targetPosition, isResumingFromBreak) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_timeline, targetItem, currentPei, seekedPosition;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                targetItem = (_this_timeline = _this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getMainContentItemForPosition(targetPosition);
                                if (!(targetItem && targetItem !== _this.currentTimelineItem)) return [
                                    3,
                                    3
                                ];
                                targetItem.resumePosition = targetPosition;
                                if (!// if the target main item is different but this was a managed seek (AdsPolicy) then
                                // we don't need to change the current timeline item (since the timeline is going to do it already)
                                !isResumingFromBreak) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.suspendTimelineItem(_this.currentTimelineItem)
                                ];
                            case 1:
                                _state.sent();
                                _this.playTimelineItem(targetItem);
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                currentPei = _this.getCurrentPlayerEngineItem();
                                seekedPosition = currentPei === null || currentPei === void 0 ? void 0 : currentPei.seek(targetPosition);
                                if (!// we need to investigate why we need to run the position handling logic immediately after the seek
                                seekedPosition) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.handlePlayerPositionUpdate(currentPei, seekedPosition)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.bufferingLimit.removeEventListeners(this);
                this.bufferingLimit.destroy();
                this.removeEventListeners(this);
                this.adTimelineItemToAd.clear();
            }
        },
        {
            key: "loadPei",
            value: function loadPei(playoutData, timelineItem) {
                var _this_logger;
                if (this.timelineState === TimelineState.Ended) {
                    return;
                }
                var playerEngineItem = this.timelinePlayerCreationHelper.createPlayerEngineItem(playoutData);
                this.addPlayerEngineItemListeners(playerEngineItem);
                // If the timeline item was pre-loaded but failed we'll also get here
                timelineItem.isPreloaded = false;
                timelineItem.isPreconstructed = false;
                this.timelineItemStartedObservable.notifyObservers({
                    timelineItem: timelineItem,
                    playerEngineItem: playerEngineItem
                });
                (_this_logger = this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("Created engine item ".concat(playerEngineItem.id, " for ").concat(timelineItem.id, " ").concat(timelineItem.asset.id, "."));
                this.playerEngineItems.set(timelineItem.asset.id, playerEngineItem);
                playerEngineItem.load();
            }
        },
        {
            key: "getItemPlayout",
            value: function getItemPlayout(nextTimelineItem, isInitialPlayout, initialPlayoutStartPosition) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_mainAsset, _ref, playoutData, mainAssetPlayoutData, isMainContent, firstCdn, modifiedPlayout;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        nextTimelineItem.asset.getPlayoutData(),
                                        (_this_mainAsset = _this.mainAsset) === null || _this_mainAsset === void 0 ? void 0 : _this_mainAsset.getPlayoutData()
                                    ])
                                ];
                            case 1:
                                _ref = _sliced_to_array.apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), playoutData = _ref[0], mainAssetPlayoutData = _ref[1];
                                if (isInitialPlayout) {
                                    playoutData.autoplay = mainAssetPlayoutData === null || mainAssetPlayoutData === void 0 ? void 0 : mainAssetPlayoutData.autoplay;
                                    playoutData.position = initialPlayoutStartPosition;
                                } else {
                                    playoutData.autoplay = true;
                                    if (nextTimelineItem.startTime !== 'start') {
                                        playoutData.position = nextTimelineItem.startTime;
                                    }
                                }
                                isMainContent = nextTimelineItem.type === TimelineItemType.MainContent;
                                if (isMainContent) {
                                    firstCdn = _this.cdnSelector.setCdns(playoutData.cdns.map(function(cdn, index) {
                                        // Inject CDN index
                                        return _object_spread_props(_object_spread({}, cdn), {
                                            index: typeof cdn.index === 'number' ? cdn.index : index
                                        });
                                    }));
                                    modifiedPlayout = _object_spread_props(_object_spread({}, playoutData), {
                                        cdns: [
                                            firstCdn
                                        ]
                                    });
                                    return [
                                        2,
                                        modifiedPlayout
                                    ];
                                }
                                playoutData.custom = _object_spread_props(_object_spread({}, playoutData.custom), {
                                    mainContentProtocol: mainAssetPlayoutData === null || mainAssetPlayoutData === void 0 ? void 0 : mainAssetPlayoutData.stream.protocol
                                });
                                return [
                                    2,
                                    playoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handlePreconstructAndPreload",
            value: function handlePreconstructAndPreload(nextTimelineItem) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_logger, nextPei, resolver, promise, playoutData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!CoreVideoInternal.playerCapabilities.preconstructItems || (nextTimelineItem === null || nextTimelineItem === void 0 ? void 0 : nextTimelineItem.isPreconstructed)) {
                                    return [
                                        2
                                    ];
                                }
                                nextPei = _this.playerEngineItems.get(nextTimelineItem.asset.id);
                                if (nextPei) {
                                    return [
                                        2
                                    ];
                                }
                                promise = new Promise(function(res) {
                                    return resolver = res;
                                });
                                _this.timelinePreconstructPreloadPromises.set(nextTimelineItem, promise);
                                nextTimelineItem.isPreconstructed = true;
                                nextTimelineItem.isPreloaded = false;
                                (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("Pre-constructing next item in timeline: ".concat(nextTimelineItem.id, " ").concat(nextTimelineItem.asset.id));
                                return [
                                    4,
                                    _this.getItemPlayout(nextTimelineItem)
                                ];
                            case 1:
                                playoutData = _state.sent();
                                _this.preconstructPei(playoutData, nextTimelineItem);
                                if (CoreVideoInternal.playerCapabilities.preloadItems) {
                                    _this.preloadTimelineItem(nextTimelineItem);
                                }
                                resolver();
                                _this.timelinePreconstructPreloadPromises.delete(nextTimelineItem);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preconstructPei",
            value: function preconstructPei(playoutData, timelineItem) {
                var _this_logger;
                var modifiedPlayout = _object_spread_props(_object_spread({}, playoutData), {
                    autoplay: false
                });
                var playerEngineItem = this.timelinePlayerCreationHelper.createPlayerEngineItem(modifiedPlayout);
                playerEngineItem.setVisibility(false);
                (_this_logger = this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("Created engine item ".concat(playerEngineItem.id, " for ").concat(timelineItem.id, " ").concat(timelineItem.asset.id, "."));
                this.playerEngineItems.set(timelineItem.asset.id, playerEngineItem);
            }
        },
        {
            key: "preloadTimelineItem",
            value: function preloadTimelineItem(timelineItem) {
                timelineItem.isPreloaded = true;
                var preconstructedPei = this.playerEngineItems.get(timelineItem.asset.id);
                this.timelineItemPreloadingObservable.notifyObservers({
                    timelineItem: timelineItem,
                    playerEngineItem: preconstructedPei
                });
                preconstructedPei === null || preconstructedPei === void 0 ? void 0 : preconstructedPei.load();
            }
        },
        {
            key: "playTimelineItem",
            value: function playTimelineItem(nextTimelineItem, isInitialPlayout, initialPlayoutStartPosition) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_logger, lastTimelineItem, existingPlayerEngineItem, playoutData, _this_logger1, _this_logger2, isResumingLoadedItem;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!nextTimelineItem) return [
                                    3,
                                    2
                                ];
                                (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info('No items left in timeline');
                                _this.timelineFinishedObservable.notifyObservers();
                                return [
                                    4,
                                    _this.endTimeline()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                lastTimelineItem = _this.currentTimelineItem;
                                existingPlayerEngineItem = _this.playerEngineItems.get(nextTimelineItem.asset.id);
                                playoutData = null;
                                if (!!existingPlayerEngineItem) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.getItemPlayout(nextTimelineItem, isInitialPlayout, initialPlayoutStartPosition)
                                ];
                            case 3:
                                playoutData = _state.sent();
                                // If we are already preconstructing/preloading we should wait for that to finish.
                                return [
                                    4,
                                    _this.timelinePreconstructPreloadPromises.get(nextTimelineItem)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                playoutData = existingPlayerEngineItem.playoutData;
                                _state.label = 6;
                            case 6:
                                _this.timelineItemPlayoutObservable.notifyObservers(playoutData);
                                if (playoutData.playoutRules) {
                                    _this.timelineItemPlayoutRulesObservable.notifyObservers(playoutData.playoutRules);
                                }
                                _this.manageFinishItemTransition(lastTimelineItem, nextTimelineItem);
                                // We must change the current timeline item after the transition is managed
                                // to allow for resuming logic to happen before proceeding
                                _this.currentTimelineItem = nextTimelineItem;
                                if (!(!existingPlayerEngineItem || !nextTimelineItem.isPreconstructed && !existingPlayerEngineItem.isActive())) return [
                                    3,
                                    7
                                ];
                                (_this_logger1 = _this.logger) === null || _this_logger1 === void 0 ? void 0 : _this_logger1.info("Playing next item in timeline: ".concat(nextTimelineItem.id, " ").concat(nextTimelineItem.asset.id));
                                _this.loadPei(playoutData, nextTimelineItem);
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                (_this_logger2 = _this.logger) === null || _this_logger2 === void 0 ? void 0 : _this_logger2.info("Resuming existing item: ".concat(existingPlayerEngineItem.id, " for ").concat(nextTimelineItem.id, "  ").concat(nextTimelineItem.asset.id, "."));
                                _this.addPlayerEngineItemListeners(existingPlayerEngineItem);
                                _this.timelineItemStartedObservable.notifyObservers({
                                    timelineItem: nextTimelineItem,
                                    playerEngineItem: existingPlayerEngineItem
                                });
                                existingPlayerEngineItem.setVisibility(true);
                                isResumingLoadedItem = nextTimelineItem.isPreloaded || existingPlayerEngineItem.state !== PlayerState.WaitingToLoad;
                                if (!isResumingLoadedItem) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _this.resumeTimelineItem(nextTimelineItem, existingPlayerEngineItem)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    13
                                ];
                            case 9:
                                return [
                                    4,
                                    _this.waitForTime(CoreVideoInternal.playerCapabilities.loadNewItemDelayMs)
                                ];
                            case 10:
                                _state.sent();
                                existingPlayerEngineItem.load();
                                return [
                                    4,
                                    existingPlayerEngineItem.waitForState([
                                        PlayerState.Playing,
                                        PlayerState.Paused,
                                        PlayerState.Stopped
                                    ])
                                ];
                            case 11:
                                _state.sent();
                                if (existingPlayerEngineItem.state === PlayerState.Stopped) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.waitForTime(CoreVideoInternal.playerCapabilities.playNewItemDelayMs)
                                ];
                            case 12:
                                _state.sent();
                                existingPlayerEngineItem.play();
                                _state.label = 13;
                            case 13:
                                _this.manageStartItemTransition(lastTimelineItem, nextTimelineItem);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resumeTimelineItem",
            value: function resumeTimelineItem(timelineItem, playerEngineItem) {
                var _this = this;
                return _async_to_generator(function() {
                    var realBreakDuration, startOffset, _this_logger;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.waitForTime(CoreVideoInternal.playerCapabilities.transitionToSuspendedItemDelayMs)
                                ];
                            case 1:
                                _state.sent();
                                if (isNumber(timelineItem.resumePosition)) {
                                    playerEngineItem.seek(timelineItem.resumePosition);
                                    timelineItem.resumePosition = null;
                                }
                                if (_this.mainContentIsLinear && timelineItem.type === TimelineItemType.MainContent && isNumber(timelineItem.startTime)) {
                                    // we need to seek over the ad slate on live streams
                                    realBreakDuration = Date.now() - _this.previousBreakStartClock / 1000;
                                    startOffset = _this.previousBreakExpectedDuration > realBreakDuration ? _this.previousBreakExpectedDuration - realBreakDuration : 0;
                                    if (startOffset) {
                                        ;
                                        (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("Adjusting resume time by -".concat(startOffset, " secs due to errors during the break"));
                                    }
                                    playerEngineItem.seek(timelineItem.startTime - startOffset);
                                }
                                return [
                                    4,
                                    _this.waitForStateForMaxTime(playerEngineItem, [
                                        PlayerState.Seeking,
                                        PlayerState.Rebuffering
                                    ], MAX_SEEKING_WAIT_MS)
                                ];
                            case 2:
                                _state.sent();
                                // This call to play causes issues for preloaded content and we might get an incorrect order of events
                                if (!timelineItem.isPreloaded) {
                                    // Calling play here fixes an issue on LG which gets stuck in rebuffering
                                    // when resuming a timeline item if it was a managed seek (seeking over the adBreak)
                                    // I wish I knew why this worked.
                                    playerEngineItem.play();
                                }
                                return [
                                    4,
                                    playerEngineItem.waitForState([
                                        PlayerState.Paused,
                                        PlayerState.Playing
                                    ])
                                ];
                            case 3:
                                _state.sent();
                                playerEngineItem.play();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "waitForStateForMaxTime",
            value: function waitForStateForMaxTime(playerEngineItem, state, timeoutMs) {
                var _this = this;
                return _async_to_generator(function() {
                    var timeout, stateEmitted;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                timeout = _this.waitForTime(timeoutMs);
                                stateEmitted = playerEngineItem.waitForState(state);
                                return [
                                    4,
                                    Promise.race([
                                        timeout,
                                        stateEmitted
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "waitForTime",
            value: function waitForTime(timeMs) {
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!timeMs) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        setTimeout(resolve, timeMs);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "manageFinishItemTransition",
            value: function manageFinishItemTransition(lastTimelineItem, nextTimelineItem) {
                // Note in "manageStartItemTransition" and "manageFinishItemTransition" methods:
                // 'Finish' events are raised before their corresponding start events
                // The last ad's finish event is raised before the ad break's finish
                // The first ad's start is raised after the ad break's start
                // So in the edge case of two consecutive ad breaks, the sequence is:
                // 1) ad ends; 2) ad break ends; 3) ad break starts; 4) ad starts
                if ((lastTimelineItem === null || lastTimelineItem === void 0 ? void 0 : lastTimelineItem.type) === TimelineItemType.Advert) {
                    var _this_adTimelineItemToAd_get;
                    var ad = (_this_adTimelineItemToAd_get = this.adTimelineItemToAd.get(lastTimelineItem)) === null || _this_adTimelineItemToAd_get === void 0 ? void 0 : _this_adTimelineItemToAd_get.ad;
                    if (ad) {
                        var _this_interItemAdPolicyManager;
                        var managedAd = (_this_interItemAdPolicyManager = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager === void 0 ? void 0 : _this_interItemAdPolicyManager.manageAdFinished(ad);
                        if (managedAd) {
                            this.session.notifyAdFinished(managedAd);
                        }
                    }
                }
                if ((nextTimelineItem === null || nextTimelineItem === void 0 ? void 0 : nextTimelineItem.type) !== TimelineItemType.Advert && (lastTimelineItem === null || lastTimelineItem === void 0 ? void 0 : lastTimelineItem.type) === TimelineItemType.Advert) {
                    if (!this.interItemAdPolicyManager) {
                        return;
                    }
                    var ad1 = this.adTimelineItemToAd.get(lastTimelineItem);
                    if (!ad1) {
                        return;
                    }
                    // Note: Since we sourced the break from the ad policy manager, it must be cloned in order to retain the original watched status before ad policy manager mutates it
                    var adBreakCopy = cloneAdBreak(ad1.adBreak);
                    var managedAdBreak = this.interItemAdPolicyManager.manageAdBreakFinished(ad1.adBreak);
                    if (managedAdBreak) {
                        this.adBreakFinishedObservable.notifyObservers(adBreakCopy);
                        if (!adBreakCopy.watched) {
                            // Note: Ad policy manager itself is source of truth for break data in this case, so we notify of watched status change here
                            this.session.notifyAdBreakDataReceived(this.interItemAdPolicyManager.getAdBreaks());
                        }
                    }
                }
            }
        },
        {
            key: "manageStartItemTransition",
            value: function manageStartItemTransition(lastTimelineItem, nextTimelineItem) {
                // Note in "manageStartItemTransition" and "manageFinishItemTransition" methods:
                // 'Finish' events are raised before their corresponding start events
                // The last ad's finish event is raised before the ad break's finish
                // The first ad's start is raised after the ad break's start
                // So in the edge case of two consecutive ad breaks, the sequence is:
                // 1) ad ends; 2) ad break ends; 3) ad break starts; 4) ad starts
                if ((nextTimelineItem === null || nextTimelineItem === void 0 ? void 0 : nextTimelineItem.type) === TimelineItemType.Advert && (lastTimelineItem === null || lastTimelineItem === void 0 ? void 0 : lastTimelineItem.type) !== TimelineItemType.Advert) {
                    this.previousBreakStartClock = Date.now();
                    this.previousBreakExpectedDuration = 0;
                    var ad = this.adTimelineItemToAd.get(nextTimelineItem);
                    if (ad) {
                        var _this_interItemAdPolicyManager;
                        var managedAdBreak = (_this_interItemAdPolicyManager = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager === void 0 ? void 0 : _this_interItemAdPolicyManager.manageAdBreakStarted(ad.adBreak);
                        if (managedAdBreak) {
                            this.previousBreakExpectedDuration = managedAdBreak.expectedDuration;
                            this.session.notifyAdBreakStarted(managedAdBreak);
                        }
                    }
                }
                if ((nextTimelineItem === null || nextTimelineItem === void 0 ? void 0 : nextTimelineItem.type) === TimelineItemType.Advert) {
                    var _this_adTimelineItemToAd_get;
                    var ad1 = (_this_adTimelineItemToAd_get = this.adTimelineItemToAd.get(nextTimelineItem)) === null || _this_adTimelineItemToAd_get === void 0 ? void 0 : _this_adTimelineItemToAd_get.ad;
                    if (ad1) {
                        var _this_interItemAdPolicyManager1, _this_playerEngineItems_get;
                        var managedAd = (_this_interItemAdPolicyManager1 = this.interItemAdPolicyManager) === null || _this_interItemAdPolicyManager1 === void 0 ? void 0 : _this_interItemAdPolicyManager1.manageAdStarted(ad1);
                        var videoElement = (_this_playerEngineItems_get = this.playerEngineItems.get(nextTimelineItem.asset.id)) === null || _this_playerEngineItems_get === void 0 ? void 0 : _this_playerEngineItems_get.videoElement;
                        if (managedAd) {
                            this.session.notifyAdStarted(_object_spread_props(_object_spread({}, managedAd), {
                                videoElement: videoElement
                            }));
                        }
                    }
                }
            }
        },
        {
            key: "suspendTimelineItem",
            value: function suspendTimelineItem(timelineItem) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.endTimelineItem(timelineItem, true)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "endTimelineItem",
            value: function endTimelineItem(timelineItem, shouldSuspend) {
                var _this = this;
                return _async_to_generator(function() {
                    var playerEngineItem, _this_logger, _this_logger1, _this_getCurrentPlayerEngineItem, err, _this_logger2;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!timelineItem) {
                                    return [
                                        2
                                    ];
                                }
                                playerEngineItem = _this.playerEngineItems.get(timelineItem.asset.id);
                                self.clearTimeout(_this.exactEndOfTimelineItemTimeout);
                                if (!playerEngineItem || !playerEngineItem.isActive()) {
                                    ;
                                    (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.warn("Tried to ".concat(shouldSuspend ? 'suspend' : 'end', " TimelineItem which doesn't have an active PlayerEngineItem associated with it."));
                                    return [
                                        2
                                    ];
                                }
                                if (_this.endingPlayerEngineItemPromise[timelineItem.asset.id]) {
                                    ;
                                    (_this_logger1 = _this.logger) === null || _this_logger1 === void 0 ? void 0 : _this_logger1.warn("Tried to ".concat(shouldSuspend ? 'suspend' : 'end', " a TimelineItem that was already ").concat(shouldSuspend ? 'suspending' : 'ending', ". Returning existing promise."));
                                    return [
                                        2,
                                        _this.endingPlayerEngineItemPromise[timelineItem.asset.id]
                                    ];
                                }
                                playerEngineItem.removeEventListeners(_this);
                                if (!shouldSuspend) return [
                                    3,
                                    3
                                ];
                                timelineItem.isSuspending = true;
                                return [
                                    4,
                                    playerEngineItem.waitForState([
                                        PlayerState.Playing,
                                        PlayerState.Paused
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                playerEngineItem.pause();
                                return [
                                    4,
                                    playerEngineItem.waitForState(PlayerState.Paused)
                                ];
                            case 2:
                                _state.sent();
                                timelineItem.isSuspending = false;
                                playerEngineItem.setVisibility(false);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                playerEngineItem.stop();
                                (_this_getCurrentPlayerEngineItem = _this.getCurrentPlayerEngineItem()) === null || _this_getCurrentPlayerEngineItem === void 0 ? void 0 : _this_getCurrentPlayerEngineItem.resetErrorObservable();
                                _this.endingPlayerEngineItemPromise[timelineItem.asset.id] = playerEngineItem.waitForState(PlayerState.Stopped);
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.endingPlayerEngineItemPromise[timelineItem.asset.id]
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                err = _state.sent();
                                (_this_logger2 = _this.logger) === null || _this_logger2 === void 0 ? void 0 : _this_logger2.error('Unable to wait for stopped state due to error', err);
                                _this.timelineErrorObservable.notifyObservers(CvsdkError.from({
                                    code: 'SDK.SESSION.TIMELINE.WAIT_FOR_STOP_FAILURE',
                                    severity: ErrorSeverity.Fatal,
                                    message: 'Unable to wait for stopped state',
                                    cause: err
                                }));
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _this.endingPlayerEngineItemPromise[timelineItem.asset.id] = null;
                                _this.timelineItemEndedObservable.notifyObservers({
                                    timelineItem: timelineItem,
                                    playerEngineItem: playerEngineItem
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleTransitionToNextItem",
            value: function scheduleTransitionToNextItem(currentTimelineItem, position, itemEndTime, logPrefix) {
                // TODO: currently if the user fast forwards past the advert start time, we play the adverts. We need to find the requirements for this,
                // it might end up being configurable (e.g. timeline items might have to have a `isPassable` as well as a `isSkippable`)
                var timeOfTransitionScheduled = new Date().getTime();
                var _this = this;
                return self.setTimeout(/*#__PURE__*/ _async_to_generator(function() {
                    var _this_logger, _this_timeline, timeSinceTransitionScheduled, currentPosition;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.timelineState !== TimelineState.Started) {
                                    return [
                                        2
                                    ];
                                }
                                timeSinceTransitionScheduled = new Date().getTime() - timeOfTransitionScheduled;
                                currentPosition = (position + timeSinceTransitionScheduled / 1000).toFixed(2);
                                (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("".concat(logPrefix, " reached end of TimelineItem (").concat(currentPosition, "/").concat(currentTimelineItem.endTime, ")"));
                                if (!(currentTimelineItem.type === TimelineItemType.MainContent && CoreVideoInternal.playerCapabilities.preconstructItems)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.suspendTimelineItem(currentTimelineItem)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.endTimelineItem(currentTimelineItem)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _this.playTimelineItem((_this_timeline = _this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getNextTimelineItem(currentTimelineItem));
                                return [
                                    2
                                ];
                        }
                    });
                }), (itemEndTime - position) * 1000);
            }
        },
        {
            key: "getLogPrefix",
            value: function getLogPrefix(playerEngineItem) {
                var _this_currentTimelineItem, _this_currentTimelineItem1;
                return "".concat(playerEngineItem.id, " (").concat((_this_currentTimelineItem = this.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.id, " ").concat((_this_currentTimelineItem1 = this.currentTimelineItem) === null || _this_currentTimelineItem1 === void 0 ? void 0 : _this_currentTimelineItem1.asset.id, ")");
            }
        },
        {
            key: "addPlayerEngineItemListeners",
            value: function addPlayerEngineItemListeners(playerEngineItem) {
                var _this = this;
                var logPrefix = this.getLogPrefix(playerEngineItem);
                var hasLoaded = false;
                var _this1 = this;
                playerEngineItem.onFinished(/*#__PURE__*/ _async_to_generator(function() {
                    var _this_currentTimelineItem, _this_logger, _this_timeline;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                perfLogger.measure(PerfKey.root, PerfTag.timelineTransitionStart);
                                (_this_logger = _this1.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.verbose("".concat(playerEngineItem.id, " (").concat((_this_currentTimelineItem = _this1.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.id, ") finished"));
                                return [
                                    4,
                                    _this1.endTimelineItem(_this1.currentTimelineItem)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this1.playTimelineItem((_this_timeline = _this1.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getNextTimelineItem(_this1.currentTimelineItem))
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }), this);
                self.clearTimeout(this.exactEndOfTimelineItemTimeout);
                playerEngineItem.onPositionChanged(function(position) {
                    return _this.handlePlayerPositionUpdate(playerEngineItem, position);
                }, this);
                var _this2 = this;
                playerEngineItem.onStateChanged(/*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(state) {
                        var _this_currentTimelineItem, _this_logger, _this_logger1;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    (_this_currentTimelineItem = _this2.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.asset.notifyStateChanged(state);
                                    (_this_logger = _this2.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("".concat(logPrefix, " in state ").concat(PlayerState[state]));
                                    self.clearTimeout(_this2.exactEndOfTimelineItemTimeout);
                                    if (!(state === PlayerState.Stopped)) return [
                                        3,
                                        2
                                    ];
                                    (_this_logger1 = _this2.logger) === null || _this_logger1 === void 0 ? void 0 : _this_logger1.info("".concat(logPrefix, " stopped, removing from cache"));
                                    _this2.playerEngineItems.delete(_this2.currentTimelineItem.asset.id);
                                    return [
                                        4,
                                        _this2.endTimeline()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    if (![
                                        PlayerState.Loading,
                                        PlayerState.Rebuffering
                                    ].includes(state)) {
                                        hasLoaded = true;
                                    }
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(state) {
                        return _ref.apply(this, arguments);
                    };
                }(), this);
                playerEngineItem.onUserStopped(function() {
                    _this.endTimeline();
                }, this);
                var _this3 = this;
                playerEngineItem.onError(/*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(error) {
                        var _this_currentTimelineItem, _this_logger, _this_currentTimelineItem1, unhandledError, _this_logger1, unhandledTimelineError;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        5,
                                        ,
                                        6
                                    ]);
                                    (_this_currentTimelineItem = _this3.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.asset.notifyError(error);
                                    (_this_logger = _this3.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.error("".concat(logPrefix, " had an error:"), error);
                                    if (error.severity === ErrorSeverity.Warning) {
                                        _this3.timelineErrorObservable.notifyObservers(error);
                                        return [
                                            2
                                        ];
                                    }
                                    if (!(((_this_currentTimelineItem1 = _this3.currentTimelineItem) === null || _this_currentTimelineItem1 === void 0 ? void 0 : _this_currentTimelineItem1.type) === TimelineItemType.MainContent && !hasLoaded && _this3.checkErrorShouldCdnSwitch(error))) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this3.attemptCdnSwitch(error)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        _this3.handleTimelineError(new TimelineError(error, _this3.currentTimelineItem.type), false)
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    unhandledError = _state.sent();
                                    // Since this promise chain is unmanaged, we should log any unhandled errors
                                    // A new error object is created to get a more accurate stack trace
                                    unhandledTimelineError = new TimelineError({
                                        message: 'Unhandled exception while processing PEI error',
                                        code: 'SDK.SESSION.TIMELINE.UNHANDLED_REJECTION',
                                        cause: unhandledError
                                    }, _this3.currentTimelineItem.type);
                                    (_this_logger1 = _this3.logger) === null || _this_logger1 === void 0 ? void 0 : _this_logger1.error(unhandledTimelineError, unhandledError);
                                    return [
                                        3,
                                        6
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(error) {
                        return _ref.apply(this, arguments);
                    };
                }(), this);
            }
        },
        {
            key: "updateAdPosition",
            value: function updateAdPosition(timelineItem, position) {
                var timelineAdBreakAd = this.adTimelineItemToAd.get(timelineItem);
                if (timelineAdBreakAd) {
                    var currentAd = timelineAdBreakAd.ad;
                    var adIndex = timelineAdBreakAd.adBreak.ads.findIndex(function(ad) {
                        return ad.id === currentAd.id;
                    });
                    var previousAdsDuration = adIndex < 1 ? 0 : timelineAdBreakAd.adBreak.ads.slice(0, adIndex).reduce(function(a, b) {
                        return a + b.expectedDuration;
                    }, 0);
                    this.session.notifyAdPositionChanged({
                        ad: currentAd,
                        adBreak: timelineAdBreakAd.adBreak,
                        adBreakPosition: previousAdsDuration + position,
                        adPosition: position
                    });
                }
            }
        },
        {
            key: "isDrmError",
            value: function isDrmError(error) {
                return /((\.|_)DRM)|((\.|_)HDCP)/gi.test(error.code);
            }
        },
        {
            key: "isBackgroundedError",
            value: function isBackgroundedError(error) {
                return /((\.|_)BACKGROUNDED)/gi.test(error.code);
            }
        },
        {
            key: "checkErrorShouldCdnSwitch",
            value: function checkErrorShouldCdnSwitch(error) {
                return error.severity === ErrorSeverity.Fatal && !this.isDrmError(error) && !this.isBackgroundedError(error);
            }
        },
        {
            key: "getCurrentPlayerEngineItem",
            value: function getCurrentPlayerEngineItem() {
                return this.playerEngineItems.get(this.currentTimelineItem.asset.id);
            }
        },
        {
            key: "getErrorStats",
            value: function getErrorStats() {
                var timelineStats = {
                    pageHref: self.location.href
                };
                return timelineStats;
            }
        },
        {
            key: "decorateTimelineErrorParameters",
            value: /**
     * Merge together timeline error stats with provided error
     * @param error
     * @returns
     */ function decorateTimelineErrorParameters(error) {
                var stats = this.getErrorStats() || {};
                error.parameters = _object_spread({}, error.parameters, JsonUtils.objToKeyValuePair(stats));
            }
        },
        {
            key: "handleTimelineError",
            value: function handleTimelineError(error, shouldFailSilently) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_currentTimelineItem, _this_currentTimelineItem1, _this_logger, _this_timeline, nextItem;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.decorateTimelineErrorParameters(error);
                                if (shouldFailSilently) {
                                    ;
                                    (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.warn('Failed with silenced error:', error);
                                } else {
                                    _this.timelineErrorObservable.notifyObservers(error);
                                }
                                if (!(((_this_currentTimelineItem = _this.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.type) === TimelineItemType.MainContent)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.endTimeline()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!(((_this_currentTimelineItem1 = _this.currentTimelineItem) === null || _this_currentTimelineItem1 === void 0 ? void 0 : _this_currentTimelineItem1.type) === TimelineItemType.Advert)) return [
                                    3,
                                    5
                                ];
                                nextItem = (_this_timeline = _this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getNextTimelineItem(_this.currentTimelineItem);
                                return [
                                    4,
                                    _this.endTimelineItem(_this.currentTimelineItem)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this.playTimelineItem(nextItem)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cdnSwitch",
            value: function cdnSwitch(cdnSwitchEvent) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_logger, _this_currentTimelineItem, _this_timeline, _this_mainAsset, isFirstTimelineItem, currentPei, failedCdns, // Assume  true unless explicit false
                    mainPlayout, _mainPlayout_autoplay, originalAutoplay, autoplay, modifiedToCdn, playoutData, playout;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info('Switching to next CDN: "'.concat(cdnSwitchEvent.toCdn.name, '"'));
                                isFirstTimelineItem = ((_this_currentTimelineItem = _this.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.asset.id) === ((_this_timeline = _this.timeline) === null || _this_timeline === void 0 ? void 0 : _this_timeline.getFirstTimelineItem().asset.id);
                                // On devices (namely Xbox) that do not have a direct mechanism for notifying when a
                                // CDN request has failed, events like `endTimelineItem` and the 'player changing to a stopped
                                // state' - they reset the BufferingLimit timer. This results in the limit never being reached during a
                                // CDN switch and so we set a flag here to prevent the BufferingLimit being reset until after
                                // we attempt the switch
                                _this.bufferingLimit.isCdnSwitching = true;
                                return [
                                    4,
                                    _this.endTimelineItem(_this.currentTimelineItem)
                                ];
                            case 1:
                                _state.sent();
                                currentPei = _this.getCurrentPlayerEngineItem();
                                failedCdns = ((currentPei === null || currentPei === void 0 ? void 0 : currentPei.playoutData.failedCdns) || []).concat(cdnSwitchEvent.fromCdn.name);
                                return [
                                    4,
                                    (_this_mainAsset = _this.mainAsset) === null || _this_mainAsset === void 0 ? void 0 : _this_mainAsset.getPlayoutData()
                                ];
                            case 2:
                                mainPlayout = _state.sent();
                                originalAutoplay = (_mainPlayout_autoplay = mainPlayout === null || mainPlayout === void 0 ? void 0 : mainPlayout.autoplay) !== null && _mainPlayout_autoplay !== void 0 ? _mainPlayout_autoplay : true;
                                autoplay = isFirstTimelineItem ? originalAutoplay : true;
                                modifiedToCdn = _object_spread({}, cdnSwitchEvent.toCdn);
                                _this.decorateTimelineErrorParameters(cdnSwitchEvent.switchError);
                                _this.cdnSwitchedObservable.notifyObservers(_object_spread_props(_object_spread({}, cdnSwitchEvent), {
                                    toCdn: modifiedToCdn,
                                    switchError: _object_spread_props(_object_spread({}, cdnSwitchEvent.switchError), {
                                        severity: ErrorSeverity.Warning
                                    })
                                }));
                                playoutData = currentPei === null || currentPei === void 0 ? void 0 : currentPei.playoutData;
                                playout = _this.sessionPrecursor.modifyPlayoutDataForCdnSwitch(_object_spread_props(_object_spread({}, playoutData), {
                                    cdns: [
                                        modifiedToCdn
                                    ],
                                    failedCdns: failedCdns,
                                    autoplay: autoplay
                                }));
                                return [
                                    4,
                                    _this.loadPei(playout, _this.currentTimelineItem)
                                ];
                            case 3:
                                _state.sent();
                                _this.bufferingLimit.isCdnSwitching = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "attemptCdnSwitch",
            value: function attemptCdnSwitch(switchError) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_mainAsset, _this_logger, selection, mainPlayout, toCdn, fromCdn, stats, _this_sessionPrecursor_sessionItem_videoFormatConfig_support, _this_sessionPrecursor_sessionItem_videoFormatConfig, _this_currentTimelineItem, _this_currentTimelineItem1, _this_logger1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                selection = _this.cdnSelector.selectNextCdn();
                                return [
                                    4,
                                    (_this_mainAsset = _this.mainAsset) === null || _this_mainAsset === void 0 ? void 0 : _this_mainAsset.getPlayoutData()
                                ];
                            case 1:
                                mainPlayout = _state.sent();
                                toCdn = selection.toCdn, fromCdn = selection.fromCdn;
                                (_this_logger = _this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info('CDN ("'.concat(fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.name, '") failed'), switchError);
                                // Attach extra diagnostics
                                stats = {
                                    totalCdns: "".concat(_this.cdnSelector.getTotalCdns()),
                                    fromCdnUrl: fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.url,
                                    fromCdnName: fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.name,
                                    fromCdnAdsUrl: fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.adsUrl,
                                    fromCdnOriginalUrl: fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.originalUrl,
                                    fromCdnIndex: "".concat(fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.index),
                                    fromCdnStreamInfo: JsonUtils.stringify(fromCdn === null || fromCdn === void 0 ? void 0 : fromCdn.streamInfo),
                                    toCdnUrl: toCdn === null || toCdn === void 0 ? void 0 : toCdn.url,
                                    toCdnName: toCdn === null || toCdn === void 0 ? void 0 : toCdn.name,
                                    toCdnAdsUrl: toCdn === null || toCdn === void 0 ? void 0 : toCdn.adsUrl,
                                    toCdnOriginalUrl: toCdn === null || toCdn === void 0 ? void 0 : toCdn.originalUrl,
                                    toCdnIndex: "".concat(toCdn === null || toCdn === void 0 ? void 0 : toCdn.index),
                                    toCdnStreamInfo: JsonUtils.stringify(toCdn === null || toCdn === void 0 ? void 0 : toCdn.streamInfo)
                                };
                                switchError.parameters = switchError.parameters || {};
                                switchError.parameters = _object_spread({}, stats);
                                if (!toCdn) return [
                                    3,
                                    3
                                ];
                                if (((_this_sessionPrecursor_sessionItem_videoFormatConfig = _this.sessionPrecursor.sessionItem.videoFormatConfig) === null || _this_sessionPrecursor_sessionItem_videoFormatConfig === void 0 ? void 0 : (_this_sessionPrecursor_sessionItem_videoFormatConfig_support = _this_sessionPrecursor_sessionItem_videoFormatConfig.support) === null || _this_sessionPrecursor_sessionItem_videoFormatConfig_support === void 0 ? void 0 : _this_sessionPrecursor_sessionItem_videoFormatConfig_support.maxVideoFormat) === VideoFormat.UHD && (mainPlayout === null || mainPlayout === void 0 ? void 0 : mainPlayout.stream.quality) === StreamQuality.UHD && _this.sessionPrecursor.sessionItem.enableQualityFailover) {
                                    return [
                                        2,
                                        _this.qualityFailoverIntercept()
                                    ];
                                }
                                return [
                                    4,
                                    _this.cdnSwitch({
                                        toCdn: toCdn,
                                        fromCdn: fromCdn,
                                        switchError: switchError
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                (_this_logger1 = _this.logger) === null || _this_logger1 === void 0 ? void 0 : _this_logger1.warn("No more CDNs for ".concat((_this_currentTimelineItem = _this.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.id, " (").concat((_this_currentTimelineItem1 = _this.currentTimelineItem) === null || _this_currentTimelineItem1 === void 0 ? void 0 : _this_currentTimelineItem1.asset.id, ")"));
                                return [
                                    4,
                                    _this.handleTimelineError(switchError, false)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TimelineManager;
}();

//# sourceMappingURL=timeline-manager.js.map